import { TimeSlot } from '../entities';
import { Reducer } from 'redux';
import { IDistibuteSchedule24, TSchedule } from '../actions';

export type ISchedule24State = TimeSlot;

export const schedule24Reducer: Reducer<ISchedule24State> = (
  state: ISchedule24State = {},
  action: IDistibuteSchedule24
): ISchedule24State => {
  switch (action.type) {
    case TSchedule.DISTRIBUTE_SCHEDULE24:
      return action.payload;
    default:
      return state;
  }
};
